/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiCompanyFromJSON, StreemApiCompanyToJSON, StreemApiUserFromJSON, StreemApiUserToJSON, } from './';
export function StreemApiCreateCompanyResponseFromJSON(json) {
    return StreemApiCreateCompanyResponseFromJSONTyped(json, false);
}
export function StreemApiCreateCompanyResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'company': !exists(json, 'company') ? undefined : StreemApiCompanyFromJSON(json['company']),
        'oidcIssuer': !exists(json, 'oidc_issuer') ? undefined : json['oidc_issuer'],
        'ownerUser': !exists(json, 'owner_user') ? undefined : StreemApiUserFromJSON(json['owner_user']),
    };
}
export function StreemApiCreateCompanyResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'company': StreemApiCompanyToJSON(value.company),
        'oidc_issuer': value.oidcIssuer,
        'owner_user': StreemApiUserToJSON(value.ownerUser),
    };
}
//# sourceMappingURL=StreemApiCreateCompanyResponse.js.map